import { v4 } from 'uuid';
import colorHelper from 'tinycolor2';

var cache = {};
var IMAGE_SOURCE_TYPE = {
  IMAGE_DATA: 'IMAGE_DATA',
  SRC_STRING: 'SRC_STRING'
};
function createImage(src, idOut) {
  var id = idOut || v4();
  var imageData = {
    src: src,
    _id: id,
    type: typeof src === 'string' ? IMAGE_SOURCE_TYPE.SRC_STRING : IMAGE_SOURCE_TYPE.IMAGE_DATA,
    delete: function _delete(id) {}
  };
  cache[id] = cache[id] || imageData;
  return imageData;
}
function clearCache(id) {
  delete cache[id];
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _defineProperty = /*@__PURE__*/getDefaultExportFromCjs(defineProperty);

var _adjust;

var EFFECTS = {
  DUOTONE: 'duotone',
  CANVAS: 'canvas',
  CHANGE_SKY: 'change-sky',
  COLOR_TONING: 'color-toning',
  MAGIC: 'magic',
  RAINBOW: 'rainbow',
  SKETCH: 'sketch',
  STYLE_TRANSFER: 'style-transfer',
  COLOR_EXPOSURE: 'color-exposure'
};
var cachingEffects = [EFFECTS.CHANGE_SKY, EFFECTS.MAGIC, EFFECTS.STYLE_TRANSFER];
var ReturnTypes = {
  CANVAS: 'CANVAS',
  BLOB: 'BLOB',
  IMAGE: 'IMAGE',
  IMAGE_DATA: 'IMAGE_DATA'
};
var BLACK_COLOR_HEX = '#000000';
var RED_COLOR_HEX = '#FF0000';
var GREEN_COLOR_HEX = '#00FF00';
var WHITE_COLOR_HEX = '#FFFFFF';
var MAGIC_ENUM = ["shamrock", "rainbow", "moonlight", "pastel", "shades_of_gray", "highlight", "midnight", "nightcore", "prettyinpink", "staygold", "wispy", "soul", "hintofyellow", "feast", "letitsnow", "geode", "sketchy", "pow", "flare", "animation", "neopop", "haze", "rosequartz", "crushedmarble", "dystopia", "rosegold", "wonderland", "winterblues", "money", "pleinair34_120"];
var fade = {
  name: 'fade',
  localizedName: 'Fade',
  defaultValue: 0,
  min: 0,
  max: 100,
  value: 0,
  type: 'NUMERIC'
};
var adjust = (_adjust = {}, _defineProperty(_adjust, EFFECTS.COLOR_EXPOSURE, {
  zoom: {
    name: 'zoom',
    type: 'NUMERIC',
    min: -20,
    max: 100,
    defaultValue: 20,
    value: 20,
    localizedNameKey: 'zoom'
  },
  rotate: {
    name: 'rotate',
    type: 'NUMERIC',
    localizedNameKey: 'rotate',
    min: -180,
    max: 180,
    value: 0,
    defaultValue: 0
  },
  color1: {
    name: 'color1',
    type: 'COLOR',
    localizedNameKey: 'color1',
    defaultValue: WHITE_COLOR_HEX,
    value: WHITE_COLOR_HEX
  },
  color2: {
    name: 'color2',
    type: 'COLOR',
    localizedNameKey: 'color2',
    defaultValue: BLACK_COLOR_HEX,
    value: BLACK_COLOR_HEX
  },
  fade: {
    name: 'fade',
    localizedName: 'Fade',
    defaultValue: 100,
    min: 0,
    max: 100,
    value: 0,
    type: 'NUMERIC'
  }
}), _defineProperty(_adjust, EFFECTS.STYLE_TRANSFER, {
  url: {
    name: 'url',
    type: 'URL',
    defaultValue: 'https://cdn130.picsart.com/94804149826827449230.jpg?type=webp',
    value: 'https://cdn130.picsart.com/94804149826827449230.jpg?type=webp',
    localizedNameKey: 'url'
  },
  fade: fade
}), _defineProperty(_adjust, EFFECTS.RAINBOW, {
  color1: {
    name: 'color1',
    type: 'COLOR',
    localizedNameKey: 'color1',
    defaultValue: WHITE_COLOR_HEX,
    value: WHITE_COLOR_HEX
  },
  color2: {
    name: 'color2',
    type: 'COLOR',
    localizedNameKey: 'color2',
    defaultValue: '',
    value: ''
  },
  color3: {
    name: 'color3',
    type: 'COLOR',
    localizedNameKey: 'color3',
    defaultValue: BLACK_COLOR_HEX,
    value: BLACK_COLOR_HEX
  },
  fade: fade
}), _defineProperty(_adjust, EFFECTS.MAGIC, {
  effectId: {
    name: 'effectId',
    type: 'ENUM',
    defaultValue: MAGIC_ENUM[0],
    value: MAGIC_ENUM[0],
    values: [].concat(MAGIC_ENUM),
    localizedNameKey: 'effect_id'
  },
  fade: fade
}), _defineProperty(_adjust, EFFECTS.COLOR_TONING, {
  color: {
    name: 'color1',
    type: 'COLOR_HEX',
    localizedNameKey: 'color1',
    defaultValue: BLACK_COLOR_HEX,
    value: BLACK_COLOR_HEX
  },
  fade: fade
}), _defineProperty(_adjust, EFFECTS.CHANGE_SKY, {
  url: {
    name: 'url',
    type: 'URL',
    localizedNameKey: 'url',
    defaultValue: 'https://pastatic.picsart.com/77848485779928228981.jpg',
    value: 'https://pastatic.picsart.com/77848485779928228981.jpg'
  }
}), _defineProperty(_adjust, EFFECTS.DUOTONE, {
  color1: {
    name: 'color1',
    type: 'COLOR',
    localizedNameKey: 'color1',
    defaultValue: WHITE_COLOR_HEX,
    value: WHITE_COLOR_HEX
  },
  color2: {
    name: 'color2',
    type: 'COLOR',
    localizedNameKey: 'color2',
    defaultValue: BLACK_COLOR_HEX,
    value: BLACK_COLOR_HEX
  },
  fade: fade
}), _adjust);

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _asyncToGenerator = /*@__PURE__*/getDefaultExportFromCjs(asyncToGenerator);

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var regenerator = runtime_1;

var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
function resizeCanvas(width, height) {
  canvas.width = width;
  canvas.height = height;
}
function clearCanvas() {
  ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, canvas.width, canvas.height);
}

/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */
function Mime() {
  this._types = Object.create(null);
  this._extensions = Object.create(null);

  for (let i = 0; i < arguments.length; i++) {
    this.define(arguments[i]);
  }

  this.define = this.define.bind(this);
  this.getType = this.getType.bind(this);
  this.getExtension = this.getExtension.bind(this);
}

/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */
Mime.prototype.define = function(typeMap, force) {
  for (let type in typeMap) {
    let extensions = typeMap[type].map(function(t) {
      return t.toLowerCase();
    });
    type = type.toLowerCase();

    for (let i = 0; i < extensions.length; i++) {
      const ext = extensions[i];

      // '*' prefix = not the preferred type for this extension.  So fixup the
      // extension, and skip it.
      if (ext[0] === '*') {
        continue;
      }

      if (!force && (ext in this._types)) {
        throw new Error(
          'Attempt to change mapping for "' + ext +
          '" extension from "' + this._types[ext] + '" to "' + type +
          '". Pass `force=true` to allow this, otherwise remove "' + ext +
          '" from the list of extensions for "' + type + '".'
        );
      }

      this._types[ext] = type;
    }

    // Use first extension as default
    if (force || !this._extensions[type]) {
      const ext = extensions[0];
      this._extensions[type] = (ext[0] !== '*') ? ext : ext.substr(1);
    }
  }
};

/**
 * Lookup a mime type based on extension
 */
Mime.prototype.getType = function(path) {
  path = String(path);
  let last = path.replace(/^.*[/\\]/, '').toLowerCase();
  let ext = last.replace(/^.*\./, '').toLowerCase();

  let hasPath = last.length < path.length;
  let hasDot = ext.length < last.length - 1;

  return (hasDot || !hasPath) && this._types[ext] || null;
};

/**
 * Return file extension associated with a mime type
 */
Mime.prototype.getExtension = function(type) {
  type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
  return type && this._extensions[type.toLowerCase()] || null;
};

var Mime_1 = Mime;

var standard = {"application/andrew-inset":["ez"],"application/applixware":["aw"],"application/atom+xml":["atom"],"application/atomcat+xml":["atomcat"],"application/atomdeleted+xml":["atomdeleted"],"application/atomsvc+xml":["atomsvc"],"application/atsc-dwd+xml":["dwd"],"application/atsc-held+xml":["held"],"application/atsc-rsat+xml":["rsat"],"application/bdoc":["bdoc"],"application/calendar+xml":["xcs"],"application/ccxml+xml":["ccxml"],"application/cdfx+xml":["cdfx"],"application/cdmi-capability":["cdmia"],"application/cdmi-container":["cdmic"],"application/cdmi-domain":["cdmid"],"application/cdmi-object":["cdmio"],"application/cdmi-queue":["cdmiq"],"application/cu-seeme":["cu"],"application/dash+xml":["mpd"],"application/davmount+xml":["davmount"],"application/docbook+xml":["dbk"],"application/dssc+der":["dssc"],"application/dssc+xml":["xdssc"],"application/ecmascript":["ecma","es"],"application/emma+xml":["emma"],"application/emotionml+xml":["emotionml"],"application/epub+zip":["epub"],"application/exi":["exi"],"application/fdt+xml":["fdt"],"application/font-tdpfr":["pfr"],"application/geo+json":["geojson"],"application/gml+xml":["gml"],"application/gpx+xml":["gpx"],"application/gxf":["gxf"],"application/gzip":["gz"],"application/hjson":["hjson"],"application/hyperstudio":["stk"],"application/inkml+xml":["ink","inkml"],"application/ipfix":["ipfix"],"application/its+xml":["its"],"application/java-archive":["jar","war","ear"],"application/java-serialized-object":["ser"],"application/java-vm":["class"],"application/javascript":["js","mjs"],"application/json":["json","map"],"application/json5":["json5"],"application/jsonml+json":["jsonml"],"application/ld+json":["jsonld"],"application/lgr+xml":["lgr"],"application/lost+xml":["lostxml"],"application/mac-binhex40":["hqx"],"application/mac-compactpro":["cpt"],"application/mads+xml":["mads"],"application/manifest+json":["webmanifest"],"application/marc":["mrc"],"application/marcxml+xml":["mrcx"],"application/mathematica":["ma","nb","mb"],"application/mathml+xml":["mathml"],"application/mbox":["mbox"],"application/mediaservercontrol+xml":["mscml"],"application/metalink+xml":["metalink"],"application/metalink4+xml":["meta4"],"application/mets+xml":["mets"],"application/mmt-aei+xml":["maei"],"application/mmt-usd+xml":["musd"],"application/mods+xml":["mods"],"application/mp21":["m21","mp21"],"application/mp4":["mp4s","m4p"],"application/mrb-consumer+xml":["*xdf"],"application/mrb-publish+xml":["*xdf"],"application/msword":["doc","dot"],"application/mxf":["mxf"],"application/n-quads":["nq"],"application/n-triples":["nt"],"application/node":["cjs"],"application/octet-stream":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"],"application/oda":["oda"],"application/oebps-package+xml":["opf"],"application/ogg":["ogx"],"application/omdoc+xml":["omdoc"],"application/onenote":["onetoc","onetoc2","onetmp","onepkg"],"application/oxps":["oxps"],"application/p2p-overlay+xml":["relo"],"application/patch-ops-error+xml":["*xer"],"application/pdf":["pdf"],"application/pgp-encrypted":["pgp"],"application/pgp-signature":["asc","sig"],"application/pics-rules":["prf"],"application/pkcs10":["p10"],"application/pkcs7-mime":["p7m","p7c"],"application/pkcs7-signature":["p7s"],"application/pkcs8":["p8"],"application/pkix-attr-cert":["ac"],"application/pkix-cert":["cer"],"application/pkix-crl":["crl"],"application/pkix-pkipath":["pkipath"],"application/pkixcmp":["pki"],"application/pls+xml":["pls"],"application/postscript":["ai","eps","ps"],"application/provenance+xml":["provx"],"application/pskc+xml":["pskcxml"],"application/raml+yaml":["raml"],"application/rdf+xml":["rdf","owl"],"application/reginfo+xml":["rif"],"application/relax-ng-compact-syntax":["rnc"],"application/resource-lists+xml":["rl"],"application/resource-lists-diff+xml":["rld"],"application/rls-services+xml":["rs"],"application/route-apd+xml":["rapd"],"application/route-s-tsid+xml":["sls"],"application/route-usd+xml":["rusd"],"application/rpki-ghostbusters":["gbr"],"application/rpki-manifest":["mft"],"application/rpki-roa":["roa"],"application/rsd+xml":["rsd"],"application/rss+xml":["rss"],"application/rtf":["rtf"],"application/sbml+xml":["sbml"],"application/scvp-cv-request":["scq"],"application/scvp-cv-response":["scs"],"application/scvp-vp-request":["spq"],"application/scvp-vp-response":["spp"],"application/sdp":["sdp"],"application/senml+xml":["senmlx"],"application/sensml+xml":["sensmlx"],"application/set-payment-initiation":["setpay"],"application/set-registration-initiation":["setreg"],"application/shf+xml":["shf"],"application/sieve":["siv","sieve"],"application/smil+xml":["smi","smil"],"application/sparql-query":["rq"],"application/sparql-results+xml":["srx"],"application/srgs":["gram"],"application/srgs+xml":["grxml"],"application/sru+xml":["sru"],"application/ssdl+xml":["ssdl"],"application/ssml+xml":["ssml"],"application/swid+xml":["swidtag"],"application/tei+xml":["tei","teicorpus"],"application/thraud+xml":["tfi"],"application/timestamped-data":["tsd"],"application/toml":["toml"],"application/ttml+xml":["ttml"],"application/ubjson":["ubj"],"application/urc-ressheet+xml":["rsheet"],"application/urc-targetdesc+xml":["td"],"application/voicexml+xml":["vxml"],"application/wasm":["wasm"],"application/widget":["wgt"],"application/winhlp":["hlp"],"application/wsdl+xml":["wsdl"],"application/wspolicy+xml":["wspolicy"],"application/xaml+xml":["xaml"],"application/xcap-att+xml":["xav"],"application/xcap-caps+xml":["xca"],"application/xcap-diff+xml":["xdf"],"application/xcap-el+xml":["xel"],"application/xcap-error+xml":["xer"],"application/xcap-ns+xml":["xns"],"application/xenc+xml":["xenc"],"application/xhtml+xml":["xhtml","xht"],"application/xliff+xml":["xlf"],"application/xml":["xml","xsl","xsd","rng"],"application/xml-dtd":["dtd"],"application/xop+xml":["xop"],"application/xproc+xml":["xpl"],"application/xslt+xml":["*xsl","xslt"],"application/xspf+xml":["xspf"],"application/xv+xml":["mxml","xhvml","xvml","xvm"],"application/yang":["yang"],"application/yin+xml":["yin"],"application/zip":["zip"],"audio/3gpp":["*3gpp"],"audio/adpcm":["adp"],"audio/amr":["amr"],"audio/basic":["au","snd"],"audio/midi":["mid","midi","kar","rmi"],"audio/mobile-xmf":["mxmf"],"audio/mp3":["*mp3"],"audio/mp4":["m4a","mp4a"],"audio/mpeg":["mpga","mp2","mp2a","mp3","m2a","m3a"],"audio/ogg":["oga","ogg","spx","opus"],"audio/s3m":["s3m"],"audio/silk":["sil"],"audio/wav":["wav"],"audio/wave":["*wav"],"audio/webm":["weba"],"audio/xm":["xm"],"font/collection":["ttc"],"font/otf":["otf"],"font/ttf":["ttf"],"font/woff":["woff"],"font/woff2":["woff2"],"image/aces":["exr"],"image/apng":["apng"],"image/avif":["avif"],"image/bmp":["bmp"],"image/cgm":["cgm"],"image/dicom-rle":["drle"],"image/emf":["emf"],"image/fits":["fits"],"image/g3fax":["g3"],"image/gif":["gif"],"image/heic":["heic"],"image/heic-sequence":["heics"],"image/heif":["heif"],"image/heif-sequence":["heifs"],"image/hej2k":["hej2"],"image/hsj2":["hsj2"],"image/ief":["ief"],"image/jls":["jls"],"image/jp2":["jp2","jpg2"],"image/jpeg":["jpeg","jpg","jpe"],"image/jph":["jph"],"image/jphc":["jhc"],"image/jpm":["jpm"],"image/jpx":["jpx","jpf"],"image/jxr":["jxr"],"image/jxra":["jxra"],"image/jxrs":["jxrs"],"image/jxs":["jxs"],"image/jxsc":["jxsc"],"image/jxsi":["jxsi"],"image/jxss":["jxss"],"image/ktx":["ktx"],"image/ktx2":["ktx2"],"image/png":["png"],"image/sgi":["sgi"],"image/svg+xml":["svg","svgz"],"image/t38":["t38"],"image/tiff":["tif","tiff"],"image/tiff-fx":["tfx"],"image/webp":["webp"],"image/wmf":["wmf"],"message/disposition-notification":["disposition-notification"],"message/global":["u8msg"],"message/global-delivery-status":["u8dsn"],"message/global-disposition-notification":["u8mdn"],"message/global-headers":["u8hdr"],"message/rfc822":["eml","mime"],"model/3mf":["3mf"],"model/gltf+json":["gltf"],"model/gltf-binary":["glb"],"model/iges":["igs","iges"],"model/mesh":["msh","mesh","silo"],"model/mtl":["mtl"],"model/obj":["obj"],"model/stl":["stl"],"model/vrml":["wrl","vrml"],"model/x3d+binary":["*x3db","x3dbz"],"model/x3d+fastinfoset":["x3db"],"model/x3d+vrml":["*x3dv","x3dvz"],"model/x3d+xml":["x3d","x3dz"],"model/x3d-vrml":["x3dv"],"text/cache-manifest":["appcache","manifest"],"text/calendar":["ics","ifb"],"text/coffeescript":["coffee","litcoffee"],"text/css":["css"],"text/csv":["csv"],"text/html":["html","htm","shtml"],"text/jade":["jade"],"text/jsx":["jsx"],"text/less":["less"],"text/markdown":["markdown","md"],"text/mathml":["mml"],"text/mdx":["mdx"],"text/n3":["n3"],"text/plain":["txt","text","conf","def","list","log","in","ini"],"text/richtext":["rtx"],"text/rtf":["*rtf"],"text/sgml":["sgml","sgm"],"text/shex":["shex"],"text/slim":["slim","slm"],"text/spdx":["spdx"],"text/stylus":["stylus","styl"],"text/tab-separated-values":["tsv"],"text/troff":["t","tr","roff","man","me","ms"],"text/turtle":["ttl"],"text/uri-list":["uri","uris","urls"],"text/vcard":["vcard"],"text/vtt":["vtt"],"text/xml":["*xml"],"text/yaml":["yaml","yml"],"video/3gpp":["3gp","3gpp"],"video/3gpp2":["3g2"],"video/h261":["h261"],"video/h263":["h263"],"video/h264":["h264"],"video/iso.segment":["m4s"],"video/jpeg":["jpgv"],"video/jpm":["*jpm","jpgm"],"video/mj2":["mj2","mjp2"],"video/mp2t":["ts"],"video/mp4":["mp4","mp4v","mpg4"],"video/mpeg":["mpeg","mpg","mpe","m1v","m2v"],"video/ogg":["ogv"],"video/quicktime":["qt","mov"],"video/webm":["webm"]};

var lite = new Mime_1(standard);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

createCommonjsModule(function (module) {
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

function loadImage(src) {
  var image = new Image();
  return new Promise(function (resolve, reject) {
    image.onload = function () {
      resolve(image);
    };

    image.onerror = function () {
      reject(new Error('load error' + src));
    };

    image.crossOrigin = "anonymous";
    image.src = src;
  });
}
function canvasToBlob(canvas, mimeType) {
  var qualityArgument = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return new Promise(function (resolve) {
    canvas.toBlob(function (blob) {
      resolve(blob);
    }, mimeType, qualityArgument);
  });
}
function readDropDownFile(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();

    reader.onload = function (evn) {
      if (!evn.target || !evn.target.result) {
        return resolve('');
      }

      return resolve(evn.target.result);
    };

    reader.readAsDataURL(file);
  });
}

function getFileFromCanvas(_x3, _x4) {
  return _getFileFromCanvas.apply(this, arguments);
}

function _getFileFromCanvas() {
  _getFileFromCanvas = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(canvas, mimeType) {
    var promise, blob, imgName, file;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            promise = new Promise(function (resolve) {
              canvas.toBlob(resolve, mimeType);
            });
            _context2.next = 3;
            return promise;

          case 3:
            blob = _context2.sent;
            imgName = "".concat(v4(), ".").concat(lite.getExtension(mimeType));
            file = new File([blob], imgName, {
              type: mimeType,
              lastModified: Date.now()
            });
            return _context2.abrupt("return", file);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getFileFromCanvas.apply(this, arguments);
}

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _slicedToArray = /*@__PURE__*/getDefaultExportFromCjs(slicedToArray);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _typeof = /*@__PURE__*/getDefaultExportFromCjs(_typeof_1);

var FetchAI = null;
function injectServiceFetchAI(fetchAi) {
  FetchAI = fetchAi;
}

function resizeImage(image, newWidth, newHeight, fileType) {
  var canvas = document.createElement('canvas');
  canvas.width = newWidth;
  canvas.height = newHeight;
  var ctx = canvas.getContext('2d');

  if (!ctx) {
    return null;
  } // Disable smoothing on all browsers


  ctx.imageSmoothingEnabled = false;
  ctx.msImageSmoothingEnabled = false;
  ctx.mozImageSmoothingEnabled = false;
  ctx.webkitImageSmoothingEnabled = false;
  ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, newWidth, newHeight);
  return canvasToBlob(canvas, fileType);
}

function calculateSize(image) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1024;
  var isSquarePhoto = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var ratio = 0;
  var width = image.width,
      height = image.height;

  if (isSquarePhoto) {
    width = size;
    height = size;
    return {
      width: width,
      height: height
    };
  }

  if (width > size) {
    ratio = size / width;
    height *= ratio;
    width = size;
    return {
      width: width,
      height: height
    };
  }

  if (height > size) {
    ratio = size / height;
    width *= ratio;
    height = size;
    return {
      width: width,
      height: height
    };
  }

  return {
    width: width,
    height: height
  };
}

function uploadPhoto(_x, _x2) {
  return _uploadPhoto.apply(this, arguments);
}

function _uploadPhoto() {
  _uploadPhoto = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(file, params) {
    var isFormData, size, isSquarePhoto, fileType, newImageData, image, _calculateSize, width, height, newFile, blob, data, res, resSid, _resSid$url$split, _resSid$url$split2, id;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isFormData = params.isFormData, size = params.size, isSquarePhoto = params.isSquarePhoto, fileType = params.fileType;
            _context.next = 3;
            return readDropDownFile(file);

          case 3:
            newImageData = _context.sent;
            _context.next = 6;
            return loadImage(newImageData);

          case 6:
            image = _context.sent;
            _calculateSize = calculateSize(image, size, isSquarePhoto), width = _calculateSize.width, height = _calculateSize.height;
            newFile = null;
            _context.prev = 9;
            _context.next = 12;
            return resizeImage(image, width, height, fileType);

          case 12:
            blob = _context.sent;

            if (blob) {
              _context.next = 15;
              break;
            }

            throw new Error('blob is ' + _typeof(blob));

          case 15:
            newFile = new File([blob], file.name);
            _context.next = 21;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](9);
            newFile = file;

          case 21:
            data = new FormData();
            data.append('image', newFile);
            _context.next = 25;
            return FetchAI.uploadImage({
              body: data,
              isFormData: isFormData
            });

          case 25:
            res = _context.sent;
            resSid = {
              url: (res.data || {}).url,
              sid: ''
            };

            if (resSid.url) {
              _resSid$url$split = resSid.url.split('picsart.com/'), _resSid$url$split2 = _slicedToArray(_resSid$url$split, 2), id = _resSid$url$split2[1];
              resSid.sid = id;
            }

            return _context.abrupt("return", resSid);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 18]]);
  }));
  return _uploadPhoto.apply(this, arguments);
}

function uploadImgFromCanvas(_x3, _x4) {
  return _uploadImgFromCanvas.apply(this, arguments);
}

function _uploadImgFromCanvas() {
  _uploadImgFromCanvas = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(canvas, params) {
    var file;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getFileFromCanvas(canvas, params.fileType);

          case 2:
            file = _context2.sent;
            _context2.next = 5;
            return uploadPhoto(file, params);

          case 5:
            return _context2.abrupt("return", _context2.sent);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _uploadImgFromCanvas.apply(this, arguments);
}

/**
 * 
 * @param {HTMLCanvasElement} canvas 
 * @param {*} returnedType 
 * @returns 
 */

function getReturnedData(_x) {
  return _getReturnedData.apply(this, arguments);
}

function _getReturnedData() {
  _getReturnedData = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(canvas) {
    var returnedType,
        returnData,
        ctx,
        blob,
        imageUrl,
        _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            returnedType = _args.length > 1 && _args[1] !== undefined ? _args[1] : ReturnTypes.IMAGE_DATA;
            _context.t0 = returnedType;
            _context.next = _context.t0 === ReturnTypes.CANVAS ? 4 : _context.t0 === ReturnTypes.BLOB ? 6 : _context.t0 === ReturnTypes.IMAGE_DATA ? 10 : _context.t0 === ReturnTypes.IMAGE ? 13 : 21;
            break;

          case 4:
            returnData = canvas;
            return _context.abrupt("break", 22);

          case 6:
            _context.next = 8;
            return canvasToBlob(canvas);

          case 8:
            returnData = _context.sent;
            return _context.abrupt("break", 22);

          case 10:
            ctx = canvas.getContext('2d');
            returnData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            return _context.abrupt("break", 22);

          case 13:
            _context.next = 15;
            return canvasToBlob(canvas);

          case 15:
            blob = _context.sent;
            imageUrl = URL.createObjectURL(blob);
            _context.next = 19;
            return loadImage(imageUrl);

          case 19:
            returnData = _context.sent;
            return _context.abrupt("break", 22);

          case 21:
            return _context.abrupt("break", 22);

          case 22:
            return _context.abrupt("return", returnData);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getReturnedData.apply(this, arguments);
}

function duotone(_x, _x2) {
  return _duotone.apply(this, arguments);
}

function _duotone() {
  _duotone = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(image, params) {
    var _params$color, color1, _params$color2, color2, _params$fade, fade, newFade, imageData, rgb1, rgb2;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _params$color = params.color1, color1 = _params$color === void 0 ? RED_COLOR_HEX : _params$color, _params$color2 = params.color2, color2 = _params$color2 === void 0 ? GREEN_COLOR_HEX : _params$color2, _params$fade = params.fade, fade = _params$fade === void 0 ? 0 : _params$fade;
            newFade = (100 - fade) / 100;
            clearCanvas();
            resizeCanvas(image.naturalWidth || image.width, image.naturalHeight || image.height);
            ctx.drawImage(image, 0, 0);
            imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            rgb1 = colorHelper(color1).toRgb();
            rgb2 = colorHelper(color2).toRgb();
            duotoneConvertor(imageData, rgb1, rgb2, newFade);
            ctx.putImageData(imageData, 0, 0);
            ctx.globalCompositeOperation = 'destination-over';
            ctx.drawImage(image, 0, 0, image.width, image.height);
            _context.next = 14;
            return getReturnedData(canvas, params.returnType);

          case 14:
            return _context.abrupt("return", _context.sent);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _duotone.apply(this, arguments);
}

function duotoneConvertor(imageData, rgb1, rgb2, newFade) {
  var gradient = gradientMap({
    r: rgb1.r,
    g: rgb1.g,
    b: rgb1.b
  }, {
    r: rgb2.r,
    g: rgb2.g,
    b: rgb2.b
  });

  for (var i = 0; i < imageData.data.length; i += 4) {
    imageData.data[i] = gradient[imageData.data[i] * 4];
    imageData.data[i + 1] = gradient[imageData.data[i + 1] * 4 + 1];
    imageData.data[i + 2] = gradient[imageData.data[i + 2] * 4 + 2];
    imageData.data[i + 3] *= newFade;
  }
}

function gradientMap(rgb1, rgb2) {
  var gradient = [];

  for (var i = 0; i < 256 * 4; i += 4) {
    gradient[i] = ((256 - i / 4) * rgb1.r + i / 4 * rgb2.r) / 256;
    gradient[i + 1] = ((256 - i / 4) * rgb1.g + i / 4 * rgb2.g) / 256;
    gradient[i + 2] = ((256 - i / 4) * rgb1.b + i / 4 * rgb2.b) / 256;
  }

  return gradient;
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function styleTransfer(_x, _x2, _x3) {
  return _styleTransfer.apply(this, arguments);
}

function _styleTransfer() {
  _styleTransfer = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(image, id, params) {
    var _cache$id;

    var sid, res, styleTransferImageUrl, returnedImage, originalImageData, coloredImageData, i;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sid = '';

            if (!((_cache$id = cache[id]) !== null && _cache$id !== void 0 && _cache$id.sid)) {
              _context.next = 5;
              break;
            }

            sid = cache[id].sid;
            _context.next = 10;
            break;

          case 5:
            _context.next = 7;
            return uploadImgFromCanvas(image, {
              isFormData: false,
              isSquarePhoto: true,
              fileType: 'image/jpeg'
            });

          case 7:
            res = _context.sent;
            sid = res.sid;
            cache[id] = _objectSpread$3(_objectSpread$3({}, cache[id]), {}, {
              sid: sid
            });

          case 10:
            _context.next = 12;
            return getStyleTransferImage({
              sid: sid,
              url: params.url
            });

          case 12:
            styleTransferImageUrl = _context.sent;
            clearCanvas();
            _context.next = 16;
            return loadImage(styleTransferImageUrl);

          case 16:
            returnedImage = _context.sent;
            resizeCanvas(image.width, image.height);
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, image.width, image.height);
            originalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            ctx.globalAlpha = (100 - params.fade) / 100;
            ctx.drawImage(returnedImage, 0, 0, returnedImage.width, returnedImage.height, 0, 0, image.width, image.height);
            coloredImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

            for (i = 3; i < originalImageData.data.length; i += 4) {
              coloredImageData.data[i] = originalImageData.data[i] && coloredImageData.data[i];
            }

            ctx.putImageData(coloredImageData, 0, 0);
            _context.next = 27;
            return getReturnedData(canvas, params.returnType);

          case 27:
            return _context.abrupt("return", _context.sent);

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _styleTransfer.apply(this, arguments);
}

function getStyleTransferImage(_x4) {
  return _getStyleTransferImage.apply(this, arguments);
}

function _getStyleTransferImage() {
  _getStyleTransferImage = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(_ref) {
    var sid, effectId, url, queries, res;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            sid = _ref.sid, effectId = _ref.effectId, url = _ref.url;
            queries = {
              sid: sid
            };
            typeof effectId === 'string' ? queries.effectSid = effectId : queries.effectUrl = url;
            _context2.next = 5;
            return FetchAI.styleTransfer({
              body: {}
            }, queries);

          case 5:
            res = _context2.sent;

            if (!res.errorMessage) {
              _context2.next = 8;
              break;
            }

            throw new Error(res.errorMessage);

          case 8:
            return _context2.abrupt("return", res.data.url);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getStyleTransferImage.apply(this, arguments);
}

function rainbow(_x, _x2) {
  return _rainbow.apply(this, arguments);
}

function _rainbow() {
  _rainbow = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(image, params) {
    var convertedImage;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            convertedImage = rainbowConvertor(image, params.color1, params.color2, params.color3, params === null || params === void 0 ? void 0 : params.fade);
            clearCanvas();
            resizeCanvas(image.naturalWidth || image.width, image.naturalHeight || image.height);
            ctx.drawImage(image, 0, 0);
            ctx.globalCompositeOperation = 'screen';
            ctx.drawImage(convertedImage, 0, 0);
            _context.next = 8;
            return getReturnedData(canvas, params.returnType);

          case 8:
            return _context.abrupt("return", _context.sent);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _rainbow.apply(this, arguments);
}

function rainbowConvertor(image, color1, color2, color3, fade) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  canvas.width = image.naturalWidth || image.width;
  canvas.height = image.naturalHeight || image.height;
  ctx.drawImage(image, 0, 0);
  ctx.globalCompositeOperation = 'source-in';
  var gradient = ctx.createLinearGradient(0, 0, image.naturalWidth || image.width, image.naturalHeight || image.height);

  if (color2) {
    gradient.addColorStop(0, color1);
    gradient.addColorStop(.5, color2);
    gradient.addColorStop(1, color3);
  } else {
    gradient.addColorStop(0, color1);
    gradient.addColorStop(1, color3);
  }

  ctx.fillStyle = gradient;
  ctx.globalAlpha = (100 - fade) / 100;
  ctx.fillRect(0, 0, image.naturalWidth || image.width, image.naturalHeight || image.height);
  return canvas;
}

function colorToning(_x, _x2) {
  return _colorToning.apply(this, arguments);
}

function _colorToning() {
  _colorToning = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(image, params) {
    var convertedImage;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            convertedImage = colorToningConvertor(image, params.color1, params === null || params === void 0 ? void 0 : params.fade);
            clearCanvas();
            resizeCanvas(image.naturalWidth || image.width, image.naturalHeight || image.height);
            ctx.drawImage(convertedImage, 0, 0);
            ctx.globalCompositeOperation = 'hard-light';
            ctx.drawImage(image, 0, 0);
            _context.next = 8;
            return getReturnedData(canvas, params.returnType);

          case 8:
            return _context.abrupt("return", _context.sent);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _colorToning.apply(this, arguments);
}

function colorToningConvertor(image, hexColor, fade) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  canvas.width = image.naturalWidth || image.width;
  canvas.height = image.naturalHeight || image.height;
  ctx.drawImage(image, 0, 0);
  ctx.globalCompositeOperation = 'source-in';
  ctx.fillStyle = hexColor;
  ctx.globalAlpha = (100 - fade) / 100;
  ctx.fillRect(0, 0, image.naturalWidth || image.width, image.naturalHeight || image.height);
  return canvas;
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function changeSky(_x, _x2, _x3) {
  return _changeSky.apply(this, arguments);
}

function _changeSky() {
  _changeSky = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(image, id, params) {
    var skyMaskImg, _cache$id, sid, res, maskImageUrl, MaskedImage, effectImage;

    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(cache[id].masks && cache[id].masks[params.effectName])) {
              _context2.next = 4;
              break;
            }

            skyMaskImg = cache[id].masks[params.effectName];
            _context2.next = 20;
            break;

          case 4:
            if (!((_cache$id = cache[id]) !== null && _cache$id !== void 0 && _cache$id.sid)) {
              _context2.next = 8;
              break;
            }

            sid = cache[id].sid;
            _context2.next = 13;
            break;

          case 8:
            _context2.next = 10;
            return uploadImgFromCanvas(image, {
              isFormData: false,
              size: 288,
              isSquarePhoto: true,
              fileType: 'image/jpeg'
            });

          case 10:
            res = _context2.sent;
            sid = res.sid;
            cache[id] = _objectSpread$2(_objectSpread$2({}, cache[id]), {}, {
              sid: sid
            });

          case 13:
            _context2.next = 15;
            return getSkyImage(sid);

          case 15:
            maskImageUrl = _context2.sent;
            _context2.next = 18;
            return loadImage(maskImageUrl);

          case 18:
            skyMaskImg = _context2.sent;
            cache[id] = _objectSpread$2(_objectSpread$2({}, cache[id]), {}, {
              masks: _objectSpread$2(_objectSpread$2({}, cache[id].masks), {}, _defineProperty({}, params.effectName, skyMaskImg))
            });

          case 20:
            MaskedImage = getMaskedImage(image, skyMaskImg);
            _context2.next = 23;
            return loadImage(params.url);

          case 23:
            effectImage = _context2.sent;
            // effectImage = resizeCloud((image.naturalWidth || image.width), (image.naturalHeight || image.height), effectImage);
            clearCanvas();
            resizeCanvas(image.width, image.height);
            ctx.globalCompositeOperation = 'source-over';
            ctx.drawImage(effectImage, 0, 0, effectImage.width, effectImage.height, 0, 0, image.width, image.height);
            ctx.drawImage(MaskedImage, 0, 0, MaskedImage.width, MaskedImage.height, 0, 0, image.width, image.height);
            _context2.next = 31;
            return getReturnedData(canvas, params.returnType);

          case 31:
            return _context2.abrupt("return", _context2.sent);

          case 32:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _changeSky.apply(this, arguments);
}

var getSkyImage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(sid) {
    var res;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return FetchAI.skyChange({}, sid);

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res.data.url);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getSkyImage(_x4) {
    return _ref.apply(this, arguments);
  };
}();

function getMaskedImage(image, mask) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  canvas.width = image.naturalWidth || image.width;
  canvas.height = image.naturalHeight || image.height;
  ctx.drawImage(image, 0, 0);
  ctx.globalCompositeOperation = 'destination-out';
  ctx.drawImage(mask, 0, 0, image.naturalWidth || image.width, image.naturalHeight || image.height);
  return canvas;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function magic(_x, _x2, _x3) {
  return _magic.apply(this, arguments);
}

function _magic() {
  _magic = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(image, id, params) {
    var _cache$id;

    var sid, res, magicImageUrl, returnedImage, originalImageData, coloredImageData, i;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sid = '';

            if (!((_cache$id = cache[id]) !== null && _cache$id !== void 0 && _cache$id.sid)) {
              _context.next = 5;
              break;
            }

            sid = cache[id].sid;
            _context.next = 10;
            break;

          case 5:
            _context.next = 7;
            return uploadImgFromCanvas(image, {
              isFormData: true,
              size: undefined,
              fileType: 'image/jpeg'
            });

          case 7:
            res = _context.sent;
            sid = res.sid;
            cache[id] = _objectSpread$1(_objectSpread$1({}, cache[id]), {}, {
              sid: sid
            });

          case 10:
            _context.next = 12;
            return applyMagicImage(sid, params.effectId);

          case 12:
            magicImageUrl = _context.sent;
            clearCanvas();
            _context.next = 16;
            return loadImage(magicImageUrl);

          case 16:
            returnedImage = _context.sent;
            resizeCanvas(image.width, image.height);
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, image.width, image.height);
            originalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            ctx.globalAlpha = (100 - params.fade) / 100;
            ctx.drawImage(returnedImage, 0, 0, returnedImage.width, returnedImage.height, 0, 0, image.width, image.height);
            coloredImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

            for (i = 3; i < originalImageData.data.length; i += 4) {
              coloredImageData.data[i] = originalImageData.data[i] && coloredImageData.data[i];
            }

            ctx.putImageData(coloredImageData, 0, 0);
            _context.next = 27;
            return getReturnedData(canvas, params.returnType);

          case 27:
            return _context.abrupt("return", _context.sent);

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _magic.apply(this, arguments);
}

function applyMagicImage(_x4, _x5) {
  return _applyMagicImage.apply(this, arguments);
}

function _applyMagicImage() {
  _applyMagicImage = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(sid, effect) {
    var res;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return FetchAI.magicEffect({
              body: {
                effect: effect,
                sid: sid
              }
            });

          case 2:
            res = _context2.sent;

            if (!res.errorMessage) {
              _context2.next = 5;
              break;
            }

            throw new Error(res.errorMessage);

          case 5:
            return _context2.abrupt("return", (res.data || {}).url);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _applyMagicImage.apply(this, arguments);
}

var degreeToRadian = function degreeToRadian(degrees) {
  return degrees * Math.PI / 180;
};

function colorExposure(_x, _x2) {
  return _colorExposure.apply(this, arguments);
}

function _colorExposure() {
  _colorExposure = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(image, params) {
    var _adjust$EFFECTS$COLOR, zoomDefaultValue, rotateDefaultValue, color1, color2, returnType, _params$rotate, rotate, _params$fade, fade, _params$zoom, zoom, originalImageData, imageData, isDoubleExposure, mirroredImage, coloredImageData, i;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _adjust$EFFECTS$COLOR = adjust[EFFECTS.COLOR_EXPOSURE], zoomDefaultValue = _adjust$EFFECTS$COLOR.zoom.defaultValue, rotateDefaultValue = _adjust$EFFECTS$COLOR.rotate.defaultValue;
            color1 = params.color1, color2 = params.color2, returnType = params.returnType, _params$rotate = params.rotate, rotate = _params$rotate === void 0 ? rotateDefaultValue : _params$rotate, _params$fade = params.fade, fade = _params$fade === void 0 ? 100 : _params$fade;
            _params$zoom = params.zoom, zoom = _params$zoom === void 0 ? zoomDefaultValue : _params$zoom;
            zoom = 1 + zoom / 100;
            clearCanvas();
            resizeCanvas(image.naturalWidth || image.width, image.naturalHeight || image.height);
            ctx.drawImage(image, 0, 0); // alpha channel end

            originalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            grayScaleImage(imageData);
            isDoubleExposure = color1 === BLACK_COLOR_HEX && color2 === WHITE_COLOR_HEX;
            ctx.putImageData(imageData, 0, 0);
            mirroredImage = colorExposureConvertor(canvas, color1, isDoubleExposure, zoom, rotate, fade);

            if (!isDoubleExposure) {
              ctx.globalCompositeOperation = 'multiply';
              ctx.rect(0, 0, canvas.width, canvas.height);
              ctx.fillStyle = color2;
              ctx.fill();
            }

            coloredImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

            for (i = 0; i < originalImageData.data.length; i += 4) {
              coloredImageData.data[i + 3] = originalImageData.data[i + 3] && coloredImageData.data[i + 3];
            }

            ctx.putImageData(coloredImageData, 0, 0);
            ctx.globalCompositeOperation = 'lighten';
            ctx.drawImage(mirroredImage, 0, 0);
            _context.next = 21;
            return getReturnedData(canvas, returnType);

          case 21:
            return _context.abrupt("return", _context.sent);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _colorExposure.apply(this, arguments);
}

function colorExposureConvertor(image, color1, isDoubleExposure, zoom, rotate, fade) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  canvas.width = image.width;
  canvas.height = image.height; // keeping the original state for alpha channel

  var alphaCanvas = document.createElement('canvas');
  var alphaCtx = alphaCanvas.getContext('2d');
  alphaCanvas.width = image.width;
  alphaCanvas.height = image.height;
  alphaCtx.translate(canvas.width / 2, canvas.height / 2);
  alphaCtx.scale(-zoom, zoom);
  alphaCtx.rotate(degreeToRadian(rotate));
  alphaCtx.drawImage(image, -canvas.width / 2, -canvas.height / 2);
  var alphaImageData = alphaCtx.getImageData(0, 0, canvas.width, canvas.height); // alpha channel end

  if (!isDoubleExposure) {
    ctx.rect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = color1;
    ctx.fill();
    ctx.globalCompositeOperation = 'multiply';
  }

  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.scale(-zoom, zoom);
  ctx.rotate(degreeToRadian(rotate));
  ctx.drawImage(image, -canvas.width / 2, -canvas.height / 2);
  var mirroredImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  for (var i = 0; i < alphaImageData.data.length; i += 4) {
    mirroredImageData.data[i + 3] = alphaImageData.data[i + 3] && mirroredImageData.data[i + 3] * fade / 100;
  }

  ctx.putImageData(mirroredImageData, 0, 0);
  return canvas;
}

function grayScaleImage(imageData) {
  var data = imageData.data;

  for (var i = 0; i < data.length; i += 4) {
    var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]; // red

    data[i] = brightness; // green

    data[i + 1] = brightness; // blue

    data[i + 2] = brightness;
  }
}

function createEffect(name) {
  var effectFunction = getRunnableFunction(name);
  var effectData = {
    _id: v4(),
    effect: effectFunction,
    getParams: function getParams() {
      return Object.values(adjust[name] || {});
    },
    delete: function _delete() {},
    name: name
  };
  return effectData;
}

function getRunnableFunction(effectName) {
  var effectFunction;

  switch (effectName) {
    case EFFECTS.DUOTONE:
      return duotone;
    // case EFFECTS.SKETCH:
    //   return sketch;

    case EFFECTS.RAINBOW:
      return rainbow;

    case EFFECTS.COLOR_TONING:
      return colorToning;

    case EFFECTS.STYLE_TRANSFER:
      return styleTransfer;

    case EFFECTS.CHANGE_SKY:
      return changeSky;

    case EFFECTS.MAGIC:
      return magic;

    case EFFECTS.COLOR_EXPOSURE:
      return colorExposure;
  }

  return effectFunction;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function runEffect(_x, _x2, _x3) {
  return _runEffect.apply(this, arguments);
}

function _runEffect() {
  _runEffect = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(imageData, effectData, restParams) {
    var image, ctx, imageImage, _ctx, result;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!cache[imageData._id].image) {
              _context.next = 4;
              break;
            }

            image = cache[imageData._id].image;
            _context.next = 21;
            break;

          case 4:
            if (!(imageData.type === IMAGE_SOURCE_TYPE.IMAGE_DATA)) {
              _context.next = 12;
              break;
            }

            image = document.createElement('canvas');
            image.width = imageData.src.width;
            image.height = imageData.src.height;
            ctx = image.getContext('2d');
            ctx.putImageData(imageData.src, 0, 0);
            _context.next = 20;
            break;

          case 12:
            _context.next = 14;
            return loadImage(imageData.src);

          case 14:
            imageImage = _context.sent;
            image = document.createElement('canvas');
            image.width = imageImage.width;
            image.height = imageImage.height;
            _ctx = image.getContext('2d');

            _ctx.drawImage(imageImage, 0, 0);

          case 20:
            cache[imageData._id].image = image;

          case 21:
            if (!cachingEffects.includes(effectData.name)) {
              _context.next = 27;
              break;
            }

            _context.next = 24;
            return effectData.effect(image, imageData._id, _objectSpread(_objectSpread({}, restParams), {}, {
              effectName: effectData.name
            }));

          case 24:
            result = _context.sent;
            _context.next = 30;
            break;

          case 27:
            _context.next = 29;
            return effectData.effect(image, _objectSpread(_objectSpread({}, restParams), {}, {
              effectName: effectData.name
            }));

          case 29:
            result = _context.sent;

          case 30:
            return _context.abrupt("return", result);

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _runEffect.apply(this, arguments);
}

export { EFFECTS, ReturnTypes, clearCache, createEffect, createImage, injectServiceFetchAI, runEffect };
